import {
    IAcadaDesconto,
    IDesconto,
    IAlcadaDescontoPorGrupo,
    IAlcadaHonorario,
} from "../../../Interfaces/Cobranca/AlcadaDesconto/AlcadaDescontoInterface";
import { IParcelaBoletos } from "../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function GetMelhorAlcadaHonorarioService(idCaso: number) {
    return Service(
        Axios.get<IAlcadaHonorario>(
            `cobranca/alcadahonorario/getmelhoralcadahonorario?idCaso=${idCaso}`
        )
    );
}

export async function GetMelhorAlcadaDescontoService(idCaso: number) {
    return Service(
        Axios.get<IAcadaDesconto>(
            `cobranca/alcadadesconto/getmelhoralcadadesconto?idCaso=${idCaso}`
        )
    );
}

export async function GetAlcadaDescontoPorIdCasoControllerService(
    idCaso: number
) {
    return Service(
        Axios.get<Array<IAcadaDesconto>>(
            `cobranca/alcadadesconto/getalcadadescontousuarioproduto?idProdutoUnidade=${idCaso}`
        )
    );
}

export async function VerificaNrAgingAlcadaService(
    NR_INICIO_AGING: number,
    NR_FIM_AGING: number,
    idConta: number,
    idCaso: number
) {
    return Service(
        Axios.get<boolean>(
            `cobranca/alcadadesconto/verificanragingalcada?NR_INICIO_AGING=${NR_INICIO_AGING}&NR_FIM_AGING=${NR_FIM_AGING}&idConta=${idConta}&idCaso=${idCaso}`
        )
    );
}

export async function CalculaDescontoJurosMultaService(
    parcelas: Array<IParcelaBoletos>,
    idCaso: number,
    valDescontoJuros: number,
    valDescontoMulta: number,
    valHonorarioP: number,
    valDescontoVlPrincipal: number
) {
    return Service(
        Axios.post<IDesconto>(
            `cobranca/boleto/calculadescontojurosmulta?idCaso=${idCaso}&valDescontoJuros=${valDescontoJuros}&valDescontoMulta=${valDescontoMulta}&valHonorarioP=${valHonorarioP}&valDescontoVlPrincipal=${valDescontoVlPrincipal}`,
            parcelas
        )
    );
}

export async function ListarAlcadaDescontoPorGrupoService(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Service(
        Axios.post<Array<IAlcadaDescontoPorGrupo>>(
            `/cobranca/alcadadesconto/listaalcadadescontoporgrupo`,
            requestBody
        )
    );
}

export async function AdicionarAlcadaDescontoService(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Service(
        Axios.post(
            `/cobranca/alcadadesconto/inseriralcadadesconto`,
            requestBody
        )
    );
}

export async function ExcluirAlcadaDescontoService(idAlcadaDesconto: number) {
    return Service(
        Axios.delete(
            `/cobranca/alcadadesconto/deletaralcadadesconto?idAlcadaDesconto=${idAlcadaDesconto}`
        )
    );
}

export async function AtualizarAlcadaDescontoService(
    requestBody: IAlcadaDescontoPorGrupo
) {
    return Service(
        Axios.put(
            `/cobranca/alcadadesconto/atualizaralcadadesconto`,
            requestBody
        )
    );
}
